import { defineMessages } from 'react-intl'

import {
  ATTR_RECOMMENDATION_ID,
  ATTR_CROP,
  ATTR_YIELD_TARGET,
  ATTR_TARGET_PH,
  ATTR_RECOMMENDATION_TYPE,
  ATTR_CONTROLLER_TYPE,
  ATTR_ELEMENTS,
  ATTR_PRODUCTS,
  ATTR_MAP_REPORTS,
  ATTR_CONTROLLER_FILES,
} from './constants'

export default defineMessages({
  [ATTR_RECOMMENDATION_ID]: {
    id: 'hfty.dataTable.recommendations.id',
    defaultMessage: 'ID',
  },
  [ATTR_CROP]: {
    id: 'hfty.dataTable.recommendations.crop',
    defaultMessage: 'Crop',
  },
  [ATTR_YIELD_TARGET]: {
    id: 'hfty.dataTable.recommendations.yield_target',
    defaultMessage: 'Yield Target',
  },
  [ATTR_TARGET_PH]: {
    id: 'hfty.dataTable.recommendations.target_pH',
    defaultMessage: 'Target pH',
  },
  [ATTR_RECOMMENDATION_TYPE]: {
    id: 'recommendation_type',
    defaultMessage: 'Recommendation Type',
  },
  [ATTR_CONTROLLER_TYPE]: {
    id: 'controller_type',
    defaultMessage: 'Controller Type',
  },
  [ATTR_ELEMENTS]: {
    id: 'elements',
    defaultMessage: 'Elements',
  },
  [ATTR_PRODUCTS]: {
    id: 'products',
    defaultMessage: 'Products',
  },
  [ATTR_MAP_REPORTS]: {
    id: 'map_reports',
    defaultMessage: 'Map Reports',
  },
  [ATTR_CONTROLLER_FILES]: {
    id: 'controller_files',
    defaultMessage: 'Controller Files',
  },
})
